<template src="./login.html"></template>

<script>
export default {
  name: "LoginForm",

  data() {
    return {
      e1: true,
      cred: {
        username: "",
        password: "",
      },
      attesa: false,
    };
  },

  methods: {
    async submit() {
      window.scrollTo(0, 0);

      if (!this.$refs.formLogin.validate()) {
        return;
      }

      this.attesa = true;

      try {
        await this.$store.dispatch("auth/login", this.cred);

        const destinazione = this.$route.query.redirect || "/";
        this.$router.push(destinazione);
      } catch (error) {
        console.log(error);
      }

      this.attesa = false;
    },
  },
};
</script>
